import { render, staticRenderFns } from "./DilekceView.vue?vue&type=template&id=1a2e0a4e"
import script from "./DilekceView.vue?vue&type=script&lang=ts"
export * from "./DilekceView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports